import { render, staticRenderFns } from "./HistoryDialog.vue?vue&type=template&id=6929e8f2&scoped=true"
import script from "./HistoryDialog.vue?vue&type=script&lang=js"
export * from "./HistoryDialog.vue?vue&type=script&lang=js"
import style0 from "./HistoryDialog.vue?vue&type=style&index=0&id=6929e8f2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6929e8f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6929e8f2')) {
      api.createRecord('6929e8f2', component.options)
    } else {
      api.reload('6929e8f2', component.options)
    }
    module.hot.accept("./HistoryDialog.vue?vue&type=template&id=6929e8f2&scoped=true", function () {
      api.rerender('6929e8f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/platformManage/resource/components/HistoryDialog.vue"
export default component.exports